export enum Rights {
  READ = 'READ',
  WRITE = 'WRITE'
}
